"use strict";

//https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/examples/dialog/
const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");
const typography = require("!!css-loader!../../tokens/typography.css").default;

class Element extends HTMLElement {

    constructor(template) {
        super();

        this.root = this.attachShadow({ mode: "open" });

        /**
         * Applying styles inside the shadow DOM:
         * @see https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_shadow_DOM#applying_styles_inside_the_shadow_dom
         */
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(typography);
        this.root.adoptedStyleSheets = [sheet];


        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);

        this._dialog = this.shadowRoot.querySelector('.swiftref-dialog');
        this._dialogContent = this._dialog.querySelector('.dialog-content');


        /**
         * Handles keyboard events for the modal
         * - Escape key closes the modal
         * - Tab key manages focus trap
         * @param {KeyboardEvent} event
         */
        this.handleKeydown = function (event) {
            // Only handle events when modal is open
            if (!this.hasAttribute('open')) return;


            if (event.key === 'Escape') {
                event.preventDefault();
                this.hide();
            }
            // else if (event.key === 'Tab') {
            //     this._handleTabKey(event);
            // }
        }.bind(this);

    }



    get open() {
        return this.hasAttribute("open");
    }
    set open(value) {
        this.setAttribute("open", "");
    }
    get submit_label() {
        return this.getAttribute("submit_label");
    }
    set submit_label(value) {
        this.setAttribute("submit_label", value);
    }


    static get observedAttributes() {
        return ["name", "open", "submit_label", "title_icon"];
    }

    attributeChangedCallback(name, oldValue, newValue) {

        switch (name) {
            case "name":
                this.shadowRoot.querySelector('#dialog-title').textContent = newValue;
                this._dialog.setAttribute("aria-labelledby", newValue);
                break;
            case "submit_label":
                try {
                    this._dialog.querySelector("#submit-button").setAttribute("label", newValue);
                } catch (e) {}
                break;
            case "open":
                setTimeout(function () {
                    if (this.open) {
                        this._dialog.classList.add("animate");
                        document.addEventListener('keydown', this.handleKeydown);
                    } else {
                        this._dialog.classList.remove("animate");
                        document.removeEventListener('keydown', this.handleKeydown);
                    }
                }.bind(this), 10);

                break;
            case "title_icon":
                this._dialog.querySelector("swiftref-icon").setAttribute("kind", newValue);
                break;
            default:
                break;
        }
    }


    connectedCallback() {
        // Setup event listeners for buttons
        this.hideButton = this.shadowRoot.querySelector('.close-icon');
        if (this.hideButton) {
            this.hideButton.addEventListener('click', this.hide.bind(this));
        }
        this.cancelButton = this.shadowRoot.querySelector('[slot="cancel"]') || this.shadowRoot.querySelector('swiftref-button[kind="secondary"]');
        if (this.cancelButton) {
            this.cancelButton.addEventListener('click', this.hide.bind(this));
        }
        this.submitButton = this.shadowRoot.querySelector('[slot="submit"]') || this.shadowRoot.querySelector('#submit-button');
        if (this.submitButton) {
            this.submitButton.addEventListener("click", this.submit.bind(this));
        }

        if (this.getAttribute("title_icon")) {
            this._dialog.querySelector("swiftref-icon").setAttribute("kind", this.getAttribute("title_icon"));
        }

    }
    /**
     * Lifecycle callback when element is removed from the DOM
     * Cleans up event listeners to prevent memory leaks
     */
    disconnectedCallback() {
        document.removeEventListener('keydown', this.handleKeydown);
        if (this.hideButton) {
            this.hideButton.removeEventListener('click', this.hide.bind(this));
        }
        if (this.cancelButton) {
            this.cancelButton.removeEventListener('click', this.hide.bind(this));
        }
        if (this.submitButton) {
            this.submitButton.removeEventListener("click", this.submit.bind(this));
        }
    }



    submit() {
        this.dispatchEvent(new CustomEvent("submit", {
            detail: {},
            // bubbles: true
            // composed: true
        }))
    }

    /**
     * Public method to open the modal
     */
    show() {
        this.setAttribute('open', '');
        this.scrollTop();
    }


    scrollTop() {
        this.previousScrollTop = this._dialogContent.scrollTop;
        this._dialogContent.scrollTop = 0;
    }
    scrollDown() {
        this.previousScrollTop = this._dialogContent.scrollTop;
        this._dialogContent.scrollTop = this._dialogContent.scrollHeight;
    }
    resetScroll() {
        this._dialogContent.scrollTop = this.previousScrollTop;
    }

    /**
     * Public method to close the modal
     */
    hide() {

        if (this.open) {
            this.dispatchEvent(new CustomEvent("hide", {
                detail: {},
                bubbles: true
                // composed: true
            }))
            this._dialog.classList.remove("animate");
            setTimeout(function () {
                this.removeAttribute('open');
            }.bind(this), 200);
            document.removeEventListener('keydown', this.handleKeydown);
        }

    }

}


window.customElements.define("swiftref-dialog", Element);

module.exports = Element;
